import React, { useState, useCallback, ReactNode } from "react";

import classNames from "classnames";

import { Collapsible } from "../Collapsible";
import { ListItem } from "../ListItem";
import { PlusIcon } from "../PlusIcon";
import * as styles from "./ExpandingSection.module.scss";

interface ExpandingSectionProps {
  title?: string | null;
  children: ReactNode;
  initialExpanded?: boolean;
  expandable?: boolean;
  topBorder?: boolean;
  className?: string;
}

const ExpandingSection: React.FC<ExpandingSectionProps> = React.forwardRef(
  (
    {
      title,
      children,
      initialExpanded = true,
      expandable = true,
      topBorder = true,
      className,
    },
    ref,
  ) => {
    const [expandToggle, setExpandToggle] = useState(initialExpanded);

    const onToggle = useCallback(() => {
      if (expandable) {
        setExpandToggle((s) => !s);
      }
    }, [expandable]);

    return (
      <div ref={ref} className={classNames(styles.outer, className)}>
        <ListItem
          size="large"
          onClick={onToggle}
          slot={
            <PlusIcon
              className={styles.icon}
              toggle={expandToggle}
              iconProps={{ size: "large" }}
            />
          }
          topBorder={topBorder}
          rightBorder={false}
          leftBorder={false}
          tagName="h2"
          noFocus={true}
        >
          {title}
        </ListItem>
        <Collapsible open={expandToggle}>{children}</Collapsible>
      </div>
    );
  },
);

export { ExpandingSection };
